import { ViewStyle } from "react-native";

import { ClassGroupType } from "../../Style.types";

export interface IPaddingClassGroup {
  p0: ViewStyle;
  p2: ViewStyle;
  p4: ViewStyle;
  p8: ViewStyle;
  p16: ViewStyle;
  p24: ViewStyle;
  p32: ViewStyle;
  p40: ViewStyle;
  p48: ViewStyle;
  p64: ViewStyle;
  ph0: ViewStyle;
  ph2: ViewStyle;
  ph4: ViewStyle;
  ph8: ViewStyle;
  ph16: ViewStyle;
  ph24: ViewStyle;
  ph32: ViewStyle;
  ph40: ViewStyle;
  ph48: ViewStyle;
  ph64: ViewStyle;
  pl16: ViewStyle;
  pl24: ViewStyle;
  pl32: ViewStyle;
  pl40: ViewStyle;
  pl48: ViewStyle;
  pl64: ViewStyle;
  pr16: ViewStyle;
  pr24: ViewStyle;
  pr32: ViewStyle;
  pr40: ViewStyle;
  pr48: ViewStyle;
  pr64: ViewStyle;
  pv0: ViewStyle;
  pv2: ViewStyle;
  pv4: ViewStyle;
  pv8: ViewStyle;
  pv16: ViewStyle;
  pv24: ViewStyle;
  pv32: ViewStyle;
  pv40: ViewStyle;
  pv48: ViewStyle;
  pv64: ViewStyle;
}

export const PaddingClassGroup: ClassGroupType<IPaddingClassGroup> = {
  p0: { padding: 0 },
  p2: { padding: 2 },
  p4: { padding: 4 },
  p8: { padding: 8 },
  p16: { padding: 16 },
  p24: { padding: 24 },
  p32: { padding: 32 },
  p40: { padding: 40 },
  p48: { padding: 48 },
  p64: { padding: 64 },
  ph0: { paddingLeft: 0, paddingRight: 0 },
  ph2: { paddingLeft: 2, paddingRight: 2 },
  ph4: { paddingLeft: 4, paddingRight: 4 },
  ph8: { paddingLeft: 8, paddingRight: 8 },
  ph16: { paddingLeft: 16, paddingRight: 16 },
  ph24: { paddingLeft: 24, paddingRight: 24 },
  ph32: { paddingLeft: 32, paddingRight: 32 },
  ph40: { paddingLeft: 40, paddingRight: 40 },
  ph48: { paddingLeft: 48, paddingRight: 48 },
  ph64: { paddingLeft: 64, paddingRight: 64 },
  pl16: { paddingLeft: 16 },
  pl24: { paddingLeft: 24 },
  pl32: { paddingLeft: 32 },
  pl40: { paddingLeft: 40 },
  pl48: { paddingLeft: 48 },
  pl64: { paddingLeft: 64 },
  pr16: { paddingRight: 16 },
  pr24: { paddingRight: 24 },
  pr32: { paddingRight: 32 },
  pr40: { paddingRight: 40 },
  pr48: { paddingRight: 48 },
  pr64: { paddingRight: 64 },
  pv0: { paddingTop: 0, paddingBottom: 0 },
  pv2: { paddingTop: 2, paddingBottom: 2 },
  pv4: { paddingTop: 4, paddingBottom: 4 },
  pv8: { paddingTop: 8, paddingBottom: 8 },
  pv16: { paddingTop: 16, paddingBottom: 16 },
  pv24: { paddingTop: 24, paddingBottom: 24 },
  pv32: { paddingTop: 32, paddingBottom: 32 },
  pv40: { paddingTop: 40, paddingBottom: 40 },
  pv48: { paddingTop: 48, paddingBottom: 48 },
  pv64: { paddingTop: 64, paddingBottom: 64 },
};